module.exports = __webpack_public_path__ + "media/audio20.0a011406.mp3";